const filterTypes = [
  { label: 'All', type: null, statsKey: 'total' },
  { label: 'Appointment', type: 'Appointment', statsKey: 'appointment_conversations' },
  { label: 'Hygiene Recare', type: 'ContinuingCare', statsKey: 'continuing_care_conversations' },
  { label: 'Treatment Plan', type: 'TreatmentPlan', statsKey: 'treatment_plan_conversations' },
]

function Filters({ activeTab, onChange, stats = {}, loading = false }) {
  return (
    <div className="px-3 py-1 border-b border-base-200 flex overflow-x-auto [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]">
      {filterTypes.map(filterType => {
        const isActive = activeTab === filterType.type
        const count = stats[filterType.statsKey]
        return (
          <button
            key={filterType.type ?? 'all'}
            onClick={() => onChange(filterType.type)}
            className={`flex items-center gap-1.5 px-3 py-1 rounded-full text-xs whitespace-nowrap transition-all ${isActive
                ? 'font-semibold text-info bg-blue-50'
                : 'font-medium text-base-content/50 hover:text-base-content/70'
              }`}
          >
            {filterType.label}
            {loading ? (
              <span className="w-6 h-4 rounded-full bg-base-200 animate-pulse" />
            ) : (
              <span className={`inline-flex items-center justify-center text-xs h-4 min-w-4 px-1 rounded-full font-semibold ${isActive ? 'bg-white text-info' : 'bg-base-200 text-base-content/40'}`}>
                {count}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}

export default Filters
